import ApiService from "./api.service";
import store from "../store/mainStore";

class WizardNewCadenceService extends ApiService {
    
    getAvailableGroups() {
        return this.get(`new-cadence-creator/groups`);
    }

    getClientAdministrators() {
        return this.get(`new-cadence-creator/users/administrators`)
    }

    getClientTemplates() {
        return this.get(`new-cadence-creator/sessions/templates`)
    }

    getAvailableLicenses() {
        return this.get(`new-cadence-creator/users/licenses`)
    }

    getAvailableAdminLicenses() {
        return this.get(`new-cadence-creator/users/admin-licenses`)
    }

    getAccountsLoginsInfo(new_kid) {
        return this.get(`new-cadence-creator/users/accountInfos/${new_kid}/to-word`, { responseType: "arraybuffer" })
    }

    createNewClientCadence(data) {
        return this.post(`new-cadence-creator/cadence/create-cadence`, data)
    }

    checkIfClientHasTransmission(){
        return this.get("new-cadence-creator/cadence/has-transmission");
    }

    allSelectedGroups() {
        return store.state.wizardNewCadence.availableGroups.filter(item => store.state.wizardNewCadence.selectedGroups.includes(item.id));
    }

    selectedGroups() {
        return store.state.wizardNewCadence.availableGroups.filter(item => store.state.wizardNewCadence.selectedGroups.includes(item.id) && item.isSessions == true);
    }

    selectedGroupsWithoutSession() {
        return store.state.wizardNewCadence.availableGroups.filter(item => store.state.wizardNewCadence.selectedGroups.includes(item.id) && item.isSessions == false);
    }

    selectedAdministrators() {
        return store.state.wizardNewCadence.availableAdministrators.filter(item => store.state.wizardNewCadence.selectedAdministrators.includes(item.id));
    }

    selectedTemplates() {
        return store.state.wizardNewCadence.availableTemplates.filter(item => store.state.wizardNewCadence.selectedTemplates.includes(item.id));
    }
}

export default new WizardNewCadenceService();